"use strict";

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dedupe = require("classnames/dedupe");

var _dedupe2 = _interopRequireDefault(_dedupe);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Util = require("../Util/Util");

var _Util2 = _interopRequireDefault(_Util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldSubmit = function (_React$Component) {
  (0, _inherits3.default)(FieldSubmit, _React$Component);

  function FieldSubmit() {
    (0, _classCallCheck3.default)(this, FieldSubmit);
    return (0, _possibleConstructorReturn3.default)(this, (FieldSubmit.__proto__ || (0, _getPrototypeOf2.default)(FieldSubmit)).apply(this, arguments));
  }

  (0, _createClass3.default)(FieldSubmit, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !_Util2.default.isEqual(this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          buttonClass = _props.buttonClass,
          columnWidth = _props.columnWidth,
          buttonText = _props.buttonText,
          formGroupClass = _props.formGroupClass,
          handleSubmit = _props.handleSubmit,
          formElementClass = _props.formElementClass;


      var rowClass = (0, _dedupe2.default)("form-row-element column-" + columnWidth, formElementClass);

      return _react2.default.createElement(
        "div",
        { className: rowClass },
        _react2.default.createElement(
          "div",
          { className: (0, _dedupe2.default)(formGroupClass) },
          _react2.default.createElement(
            "div",
            { className: (0, _dedupe2.default)(buttonClass), onClick: handleSubmit },
            buttonText
          )
        )
      );
    }
  }]);
  return FieldSubmit;
}(_react2.default.Component);

FieldSubmit.defaultProps = {
  buttonText: "Submit",
  handleSubmit: function handleSubmit() {}
};

var classPropType = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);

FieldSubmit.propTypes = {
  // Optional number of columns to take up of the grid
  columnWidth: _react2.default.PropTypes.number.isRequired,

  // Function to handle when form is submitted
  // (usually passed down from form definition)
  handleSubmit: _react2.default.PropTypes.func,

  // Text inside button
  buttonText: _react2.default.PropTypes.string,

  // Classes
  buttonClass: classPropType,
  formGroupClass: classPropType,
  formElementClass: classPropType
};

module.exports = FieldSubmit;


//////////////////
// WEBPACK FOOTER
// ./~/reactjs-components/lib/Form/FieldSubmit.js
// module id = 1308
// module chunks = 2